(function () {
    'use strict';
    var controllerId = 'disattivaSessione';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', "sessionId", disattivaSessione]);

    function disattivaSessione($scope, $uibModalInstance, datacontext, sessionId) {
        $scope.sessionId = sessionId;
        $scope.disable = disattiva;        

        $scope.cancel = function () {            
            $uibModalInstance.dismiss('cancel');
        };

        function disattiva() {
            datacontext.session_disable($scope.sessionId).then(function (data) {
                if (data == null) {
                    return;
                }
                $uibModalInstance.close(true);
            });
        }
    }
})();